import React from "react";
import { LegalLayout, Section } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="January 2026">
      <p>
        These terms govern your use of the Invextiing investor portal. By signing in you agree to them.
        If you do not agree, please do not use the portal.
      </p>

      <Section heading="1. Eligibility and account access">
        <p>
          Portal accounts are issued only to onboarded Invextiing clients and authorised staff. You are
          responsible for keeping your password confidential and for all activity under your account.
          Notify us immediately if you suspect unauthorised access.
        </p>
      </Section>

      <Section heading="2. Nature of the information shown">
        <p>
          The figures displayed in the portal, including invested capital, daily profit amounts and
          percentages, overall return percentages, and expected withdrawal dates, are reporting values
          maintained by Invextiing administrators. They are provided for your information and
          record-keeping.
        </p>
      </Section>

      <Section heading="3. Not investment advice">
        <p>
          Nothing in this portal, including market notifications, constitutes investment advice, a
          recommendation, or an offer to buy or sell any security. Investments carry risk, including
          the risk of loss of capital. Past performance is not indicative of future results.
        </p>
      </Section>

      <Section heading="4. Withdrawals">
        <p>
          Withdrawal entries and their statuses (Pending, Approved, Rejected, Completed) reflect the
          operational state recorded by Invextiing. The next expected withdrawal date is an estimate and
          not a guarantee of payment on that date.
        </p>
      </Section>

      <Section heading="5. Acceptable use">
        <p>
          You agree not to attempt to access data belonging to other clients, to probe or test the
          security of the platform, to automate access without written permission, or to interfere with
          the availability of the service.
        </p>
      </Section>

      <Section heading="6. Availability">
        <p>
          We aim for continuous availability but the portal may be unavailable during maintenance or
          due to circumstances beyond our control. We are not liable for losses arising from temporary
          unavailability.
        </p>
      </Section>

      <Section heading="7. Changes to these terms">
        <p>
          We may update these terms from time to time. Material changes will be communicated through a
          portal notification. Continued use after such notice constitutes acceptance.
        </p>
      </Section>

      <Section heading="8. Governing law">
        <p>
          These terms are governed by the laws of India, and the courts of India shall have exclusive
          jurisdiction over any dispute arising from them.
        </p>
      </Section>
    </LegalLayout>
  );
}
